module.exports = __webpack_public_path__ + "static/media/anne.fc9e655d.jpg";